export const NOT_FOUND_IN_BUREAU = 'notFoundInBureau';
export const BUREAU_GET_QS_FAILED = 'bureauGetQsFailed';
export const SSN_VERIFICATION_FAILED = 'ssnVerificationFailed';
export const SSN_VERIFIED = 'ssnVerified';
export const CS_ENROLLED = 'csEnrolled';
export const ID_VERIFICATION_PENDING = 'idVerificationPending';
export const ID_VERIFICATION_SUBMITTED = 'idVerificationSubmitted';
export const ID_VERIFICATION_FAILED = 'idVerificationFailed';
export const ID_VERIFICATION_VERIFIED = 'idVerified';
